import React from 'react';

export function SearchByCampusOrientations() {
  return <h1>Orientações - Consulta por Campus</h1>;
}
